// src/components/Providers.js
"use client";
import React from "react";
import { Provider } from "react-redux";
import PropTypes from "prop-types";

import { store } from "@/lib/redux/store";

const Providers = ({ children }) => (
  <Provider store={store}>
    {children}
  </Provider>
);

Providers.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Providers;
